// ─── Fiche d'un ingrédient — LECTURE SEULE (règle app-wide) ───────
// Clic sur un ingrédient = cette fiche, jamais l'édition directe (c'était le
// cas avant : le tap ouvrait le formulaire). 🛒, ✏️ et 🗑️ dans l'en-tête ;
// le swipe sur la carte reste un raccourci vers l'édition et la suppression.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Feuille, HIT, useUI, useT } from '@mop/core';

export default function FicheIngredient({
  visible, ingredient, rayon, onFermer, onEditer, onSupprimer, onAjouterListe,
}) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);

  if (!visible || !ingredient) return null;
  const i = ingredient;

  return (
    <Feuille visible titre={i.nom} emoji={rayon?.emoji || '🥕'} hauteur={0.45} onFermer={onFermer}
      boutons={(
        <>
          {/* 🛒 ouvre la feuille d'ajout au niveau de l'ÉCRAN : deux <Modal>
              natives imbriquées figent l'app. */}
          <TouchableOpacity onPress={onAjouterListe} hitSlop={HIT} accessibilityLabel={t('courses.ajouterALaListe')}>
            <Text style={s.hIc}>🛒</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={onEditer} hitSlop={HIT} accessibilityLabel={t('commun.editer')}>
            <Text style={s.hIc}>✏️</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={onSupprimer} hitSlop={HIT} accessibilityLabel={t('commun.supprimer')}>
            <Text style={[s.hIc, { color: UI.danger }]}>🗑️</Text>
          </TouchableOpacity>
        </>
      )}>

      <View style={s.ligne}>
        <Text style={s.lbl}>{t('ingredients.rayon')}</Text>
        <Text style={s.val}>{rayon ? `${rayon.emoji} ${rayon.label}` : '—'}</Text>
      </View>
      <View style={s.ligne}>
        <Text style={s.lbl}>{t('ingredients.unite')}</Text>
        <Text style={s.val}>{i.unite || '—'}</Text>
      </View>

      {(i.origine === 'perso' || i.modifie) && (
        <View style={s.badges}>
          {i.origine === 'perso' && <Text style={s.badge}>{t('ingredients.perso')}</Text>}
          {i.modifie && <Text style={[s.badge, s.badgeModifie]}>{t('ingredients.modifieBadge')}</Text>}
        </View>
      )}
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  hIc: { fontSize: 18, color: UI.accent },
  ligne: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 11, borderBottomWidth: 0.5, borderBottomColor: UI.border },
  lbl: { fontSize: 13, color: UI.muted, fontWeight: '600' },
  val: { fontSize: 14.5, color: UI.ink, fontWeight: '700' },
  badges: { flexDirection: 'row', gap: 8, marginTop: 14 },
  badge: { fontSize: 11, fontWeight: '800', color: UI.accent, backgroundColor: UI.card, borderRadius: 999, borderWidth: 0.5, borderColor: UI.border, paddingVertical: 3, paddingHorizontal: 9 },
  badgeModifie: { color: UI.muted },
});
